import { prefsStore, usePrefsValue } from '@adiox/ui';

const DEVICE_KEY = 'adiox.guideSeen';

const seenOnDevice = () => {
  try {
    return localStorage.getItem(DEVICE_KEY) === '1';
  } catch {
    return false;
  }
};

/** Remembers that the guide was seen or skipped: in the synced settings (every device) and on this one (at once). */
export function markGuideSeen(): void {
  prefsStore.set('guideSeen', true);
  try {
    localStorage.setItem(DEVICE_KEY, '1');
  } catch {
    // private mode: the synced setting still remembers
  }
}

/** Whether the guide should open by itself: a trader who has not seen or skipped it yet. */
export function useGuideDue(): boolean {
  const seen = usePrefsValue((s) => s.data.guideSeen === true);
  return !seen && !seenOnDevice();
}
